<template>
  <BaseChoice
    title="関連付ける先生を選択してください"
    resourceType="teacher"
    :fields="fields"
    :items="teacher.teachers"
    :totalItems="totalTeachers"
    :isFetching="isFetching"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseChoice from '@/views/choices/Base.vue';
import isEmpty from 'lodash/isEmpty';

export default {
  data() {
    return {
      isFetching: false,
    };
  },
  components: {
    BaseChoice,
  },
  mounted() {
    let filterBy = {};

    if (this.prevFormData.corporation) {
      filterBy.corporationId = this.prevFormData.corporation.id;
    }

    if (this.prevFormData.brand) {
      filterBy.brandId = this.prevFormData.brand.id;
    }

    if (!isEmpty(this.excludeItems)) {
      filterBy.excludeItems = this.excludeItems;
    }

    this.$logger.debug('Start fetching Teacher for Choices');
    this.clearTeachers();
    this.isFetching = true;
    this.fetchTeachers({ data: { filterBy } }).then(() => {
      this.isFetching = false;
      this.$logger.debug('Done fetching Teacher for Choices');
    });
  },
  computed: {
    fields() {
      return [
        {
          key: 'uid',
          label: '先生ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '先生名',
          sortable: true,
          thAttr: { width: 300 },
        },
        {
          key: 'choiceResource',
          label: '選択',
          sortable: false,
          thAttr: { width: 60 },
        },
      ];
    },
    ...mapState(['teacher']),
    ...mapGetters('teacher', ['totalTeachers']),
    ...mapState('form', ['prevFormData', 'excludeItems']),
  },
  methods: {
    ...mapActions('teacher', ['fetchTeachers', 'clearTeachers']),
  },
};
</script>
